export default "__VITE_ASSET__BpHBGzXr__"